import { render } from "./BookingRequest.vue?vue&type=template&id=7f2c632c&scoped=true"
import script from "./BookingRequest.vue?vue&type=script&lang=js"
export * from "./BookingRequest.vue?vue&type=script&lang=js"

import "./BookingRequest.vue?vue&type=style&index=0&id=7f2c632c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f2c632c"]])

export default __exports__